import { Controller } from "@hotwired/stimulus"

// A section whose body collapses behind its heading. Used by the Seasons index
// so Drafts — which most organizers accumulate and rarely revisit — doesn't
// dominate the top of the page.
//
//   data-controller="collapsible-section"
//   data-collapsible-section-key-value="seasons:drafts"
//   data-collapsible-section-open-value="false"   ← default when nothing stored
//
// The open state persists and is restored on connect(), because the index
// re-renders on every visit and would otherwise snap back to the server default.
export default class extends Controller {
  static targets = ["body", "chevron", "count"]
  static values = {
    key: String,
    open: { type: Boolean, default: true },
    // Ignore the stored preference this render — used when a search has
    // already decided the section is relevant.
    force: { type: Boolean, default: false },
  }

  connect() {
    const stored = localStorage.getItem(this.storageKey)
    this.open =
      this.forceValue || (stored === null ? this.openValue : stored === "true")
    this.render()
  }

  toggle() {
    this.open = !this.open
    try {
      localStorage.setItem(this.storageKey, String(this.open))
    } catch (_) {
      /* non-sticky */
    }
    this.render()
  }

  render() {
    this.bodyTarget.classList.toggle("hidden", !this.open)
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-90", this.open)
    }
    this.element.setAttribute("data-open", String(this.open))
    if (this.hasCountTarget) {
      // The count is the only hint of what's inside once collapsed, so keep it
      // visible in that state and out of the way when the list is on show.
      this.countTarget.classList.toggle("hidden", this.open)
    }
  }

  get storageKey() {
    return `collapsible:${this.keyValue}`
  }
}
